import React from 'react';

import PropTypes from 'prop-types';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { WhiteModal, MEDIA_QUERIES } from '@sm360/widget-commons-general';

import SignInContent from 'login/components/SignIn/SignInContent/SignInContent.jsx';

import MediaQuery from 'react-responsive';

import { LOGIN as MODAL } from 'login/constants/modalNames.js';

import 'login/components/SignIn/SignInModal.scss';

const czGroupName = 'widget.login.forms.login';

const SignInModal = ({ hasAdobeTagging }) => {
    const modalBackgroundImageUrl =
        ContentZonesService.getContentZone(czGroupName, 'background') &&
        ContentZonesService.getContentZone(czGroupName, 'background').getValue();

    return (
        <WhiteModal
            name={MODAL}
            contentLabel="dialog with form for Sign in"
            className="widget-login-popupElement"
            isScrollable
            isClosable
            backgroundImage={modalBackgroundImageUrl}
        >
            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                <SignInContent classParam="is-scrollable" hasAdobeTagging={hasAdobeTagging} />
            </MediaQuery>
            <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                <SignInContent hasAdobeTagging={hasAdobeTagging} />
            </MediaQuery>
        </WhiteModal>
    );
};

SignInModal.propTypes = {
    hasAdobeTagging: PropTypes.bool,
};

SignInModal.defaultProps = {
    hasAdobeTagging: false,
};

SignInModal.displayName = 'SignInModal';

export default SignInModal;
